import React, { useEffect, useState } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import {TextField,  Grid,  Box,  FormControl,  Select,  MenuItem,  Typography,  Card,  FormControlLabel,  Checkbox,  CardContent, InputLabel} from '@mui/material';
import statelist from '../../../../utils/StateDistList.json'
export default function AddressDetails(props) {
  const {customer} = props;
  const {control,watch,reset,setValue} = useFormContext();
  const addressMode = watch('addressMode');
  const getFullName = ()=>{
    if(customer.profile){
      // let fullName = [
      //     customer.profile.firstName,
      //     customer.profile?.middleName || '',
      //     customer.profile.lastName
      //   ].filter(Boolean).join(" ");
      let fullName = `${customer.profile.firstName || ''} ${customer.profile.middleName || ''} ${customer.profile.lastName || ''}`.replace(/\s+/g, ' ').trim();
      return fullName
    }else{
      return ''
    }
  }
  return (
    
    <Grid container sx={{p:'2% 5%'}}>
      <Grid item xs={12}>
        <Grid container spacing={2}>
        <Grid item xs={12}>
            <Box>
              {/* <Typography sx={{ fontSize:'0.85rem',fontWeight:600,fontFamily: 'Poppins' }}>Flat/House No<span style={{color:'#d32f2f'}}>*</span></Typography> */}
              <Controller
                control={control}
                name='address'
                rules={{
                  validate:(value)=>{
                    if (!value) return 'Empty Not allowed';
                    return true;
                  }
                }}
                render={({field,fieldState:{error}})=>(
                  <TextField
                    {...field}
                    inputProps={{
                      style:{
                        fontSize:'0.75rem'
                      }
                    }}
                    disabled={!watch('address')}
                    // value={PersonalDetails[prefix]?.address}
                    fullWidth
                    size='small'
                    // disabled={disabled}
                    error={!!error}
                  />
                )}
              />  
            </Box> 
          </Grid>
          {/* <Grid item xs={12} lg={3}>
            <Typography sx={{ fontSize:'0.75rem',fontWeight:600,fontFamily: 'Poppins' }}>Address Type<span style={{color:'#d32f2f'}}>*</span></Typography>
            <Controller
              name='addressType'
              control={control}
              rules={{
                required:'required'
              }}
              render={({field,fieldState:{error}})=>(
                <FormControl fullWidth size='small'>
                  <Select
                    labelId="demo-simple-select-label"
                    {...field}
                    value={field.value || ''}
                    label='Address Type'
                    sx={{
                      // minHeight: '0px',
                      // height: '1.6rem',
                      fontSize: '0.75rem',
                      '& .MuiSelect-select': {
                        // padding: '0 8px',
                        display: 'flex',
                        alignItems: 'center',
                      },
                    }}
                    error={!!error}
                  >
                    <MenuItem sx={{fontSize:'0.75rem'}} value='1'>Home</MenuItem>
                    <MenuItem sx={{fontSize:'0.75rem'}} value='2'>Work</MenuItem>
                    <MenuItem sx={{fontSize:'0.75rem'}} value='3'>Other</MenuItem>
                  </Select>
                </FormControl>
              )}
            />
          </Grid> */}
          <Grid item xs={12} lg={8}>
            <Typography sx={{ fontSize:'0.75rem',fontWeight:600,fontFamily: 'Poppins' }}>FullName</Typography>
            <Controller
                control={control}
                name='fullName'
                rules={{
                  pattern:{
                    value:/^[a-zA-Z ]*$/,
                    message:"Only Alphabets are allowed"
                  }
                }}
                render={({field,fieldState:{error}})=>(
                  <TextField
                    {...field}
                    onChange={(e)=>{
                      const value = e.target.value;
                      if(value == '' || null){
                        field.onChange(getFullName())
                      }
                      else{
                        field.onChange(value)
                      }
                    }}
                    inputProps={{
                      style:{
                        fontSize:'0.75rem'
                      }
                    }}
                    fullWidth
                    size='small'
                    error={!!error}
                  />
                )}
              />
            
          </Grid>
          <Grid item xs={12} lg={4}>
            <Typography sx={{ fontSize:'0.75rem',fontWeight:600,fontFamily: 'Poppins' }}>Mobile Number</Typography>
            <TextField
              size='small'
              fullWidth
              disabled
              value={watch('mobileNumber')}
              InputProps={{
                style:{
                  fontSize:'0.75rem'
                }
              }}
            />
          </Grid>
          <Grid item xs={12} lg={5}>
            <Box>
              <Typography sx={{ fontSize:'0.85rem',fontWeight:600,fontFamily: 'Poppins' }}>Flat/House No</Typography>
              <Controller
                control={control}
                name='houseFlatBlockNo'
                rules={{
                  // validate:(value)=>{
                  //   if (!value) return 'Empty Not allowed';
                  //   return true;
                  // }
                }}
                render={({field,fieldState:{error}})=>(
                  <TextField
                    {...field}
                    inputProps={{
                      style:{
                        fontSize:'0.75rem'
                      }
                    }}
                    // value={PersonalDetails[prefix]?.address}
                    fullWidth
                    size='small'
                    // disabled={disabled}
                    error={!!error}
                  />
                )}
              />  
            </Box> 
          </Grid>
          <Grid item xs={2}/>
          <Grid item xs={12} lg={5}>
            <Box>
              <Typography sx={{ fontSize:'0.85rem',fontWeight:600,fontFamily: 'Poppins' }}>Apartment/ Road/ Area</Typography>
              <Controller
                control={control}
                name='apartmentRoadArea'
                rules={{
                  // required:'required',
                }}
                render={({field,fieldState:{error}})=>(
                  <TextField
                    {...field}
                    inputProps={{
                      style:{
                        fontSize:'0.75rem'
                      }
                    }}
                    // value={PersonalDetails[prefix]?.address}
                    fullWidth
                    size='small'
                  />
                )}
              />  
            </Box> 
          </Grid>

          <Grid item xs={12} lg={5}>
            <Box>
              <Typography sx={{ fontSize:'0.85rem',fontWeight:600,fontFamily: 'Poppins' }}>Landmark</Typography>
              <Controller
                control={control}
                name='landmark'
                render={({field,fieldState:{error}})=>(
                  <TextField
                    {...field}
                    inputProps={{
                      style:{
                        fontSize:'0.75rem'
                      }
                    }}
                    // value={PersonalDetails[prefix]?.address}
                    fullWidth
                    size='small'
                  />
                )}
              />  
            </Box> 
          </Grid>
          <Grid item xs={2}/>
          <Grid item xs={12} lg={5}>
            <Box>
              <Typography sx={{ fontSize:'0.85rem',fontWeight:600,fontFamily: 'Poppins' }}>State<span style={{color:'#d32f2f'}}>*</span></Typography>
              <Controller
                control={control}
                name='state'
                rules={{
                  validate:(value)=>{
                    if (!value) return 'Empty Not allowed';
                    return true;
                  }
                }}
                render={({field,fieldState:{error}})=>(
                  <FormControl fullWidth size='small'>
                    <Select
                      {...field}
                      value={field.value || ''}
                      disabled={addressMode=='select_address'}
                      sx={{
                        // minHeight: '0px',
                        // height: '1.6rem',
                        fontSize: '0.75rem',
                        '& .MuiSelect-select': {
                          // padding: '0 8px',
                          display: 'flex',
                          alignItems: 'center',
                        },
                      }}
                      error={!!error}
                    >
                      {statelist.map((listItem,index)=>(
                        <MenuItem sx={{fontSize:'0.75rem'}} key={index} value={listItem.state}>{listItem.state}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              />  
            </Box> 
          </Grid>

          
          <Grid item xs={12} lg={5}>
            <Box>
              <Typography sx={{ fontSize:'0.85rem',fontWeight:600,fontFamily: 'Poppins' }}>City<span style={{color:'#d32f2f'}}>*</span></Typography>
              <Controller
                control={control}
                name='city'
                rules={{
                  validate:(value)=>{
                    if (!value) return 'Empty Not allowed';
                    return true;
                  }
                }}
                render={({field,fieldState:{error}})=>(
                  <TextField
                    {...field}
                    inputProps={{
                      style:{
                        fontSize:'0.75rem'
                      }
                    }}
                    // value={PersonalDetails[prefix]?.address}
                    fullWidth
                    size='small'
                    // disabled={disabled}
                    error={!!error}
                  />
                )}
              />  
            </Box> 
          </Grid>
          <Grid item xs={2} />
          <Grid item xs={12} lg={5}>
            <Box>
              <Typography sx={{ fontSize:'0.85rem',fontWeight:600,fontFamily: 'Poppins' }}>Pincode<span style={{color:'#d32f2f'}}>*</span></Typography>
              <Controller
                control={control}
                name='pincode'
                rules={{
                  validate:(value)=>{
                    if (!value) return 'Empty Not allowed';
                    return true;
                  }
                }}
                render={({field,fieldState:{error}})=>(
                  <TextField
                    {...field}
                    inputProps={{
                      style:{
                        fontSize:'0.75rem'
                      }
                    }}
                    type='number'
                    // value={PersonalDetails[prefix]?.address}
                    fullWidth
                    size='small'
                    // disabled={disabled}
                    error={!!error}
                  />
                )}
              />  
            </Box> 
          </Grid>
          <Grid item xs={12} lg={5}>
            <Box>
              <Typography sx={{ fontSize:'0.85rem',fontWeight:600,fontFamily: 'Poppins' }}>Latitude<span style={{color:'#d32f2f'}}>*</span></Typography>
              <Controller
                control={control}
                name='latitude'
                rules={{
                  validate:(value)=>{
                    if (!value) return 'Empty Not allowed';
                    return true;
                  }
                }}
                render={({field,fieldState:{error}})=>(
                  <TextField
                    {...field}
                    inputProps={{
                      style:{
                        fontSize:'0.75rem'
                      }
                    }}
                    type='number'
                    // value={PersonalDetails[prefix]?.address}
                    fullWidth
                    size='small'
                    // disabled={disabled}
                    error={!!error}
                  />
                )}
              />  
            </Box> 
          </Grid>
          <Grid item xs={2} />
          <Grid item xs={12} lg={5}>
            <Box>
              <Typography sx={{ fontSize:'0.85rem',fontWeight:600,fontFamily: 'Poppins' }}>Longitude<span style={{color:'#d32f2f'}}>*</span></Typography>
              <Controller
                control={control}
                name='longitude'
                rules={{
                  validate:(value)=>{
                    if (!value) return 'Empty Not allowed';
                    return true;
                  }
                }}
                render={({field,fieldState:{error}})=>(
                  <TextField
                    {...field}
                    inputProps={{
                      style:{
                        fontSize:'0.75rem'
                      }
                    }}
                    type='number'
                    // value={PersonalDetails[prefix]?.address}
                    fullWidth
                    size='small'
                    // disabled={disabled}
                    error={!!error}
                  />
                )}
              />  
            </Box> 
          </Grid>
        </Grid>
      </Grid>
    </Grid>
        
  );
}